import { useState } from 'react';
import { Button } from '@mui/material';
import { RefreshCw } from 'lucide-react';
import { useAuth } from '../../hooks';
import dayjs from 'dayjs';
import { useBookings } from '../../hooks/booking/useBookings';
import { SEVERITY } from '../../types/notification';
import Notifications from '../../components/common/Notifications';

type Props = {
  selectedResource?: number;
  dateRange: { start: string; end: string };
};

const BookingRefreshButton = ({ selectedResource, dateRange }: Props) => {
  const { role, clientResourceId } = useAuth();
  const { refetch } = useBookings();
  const [notification, setNotification] = useState({
    open: false,
    message: '',
    severity: SEVERITY.SUCCESS,
  });

  const handleRefresh = async () => {
    try {
      if (!dateRange?.start || !dateRange?.end) return;

      const startDate = dayjs(dateRange.start).format('YYYY-MM-DDTHH:mm');
      const endDate = dayjs(dateRange.end).format('YYYY-MM-DDTHH:mm');

      if (role === 'admin' && selectedResource) {
        await refetch(selectedResource, startDate, endDate);
      }
      if (role === 'client_admin') {
        if (!selectedResource) {
          if (!clientResourceId) {
            setNotification({
              open: true,
              message: 'Please select a resource before refreshing bookings',
              severity: SEVERITY.ERROR,
            });
            return;
          }
          await refetch(clientResourceId, startDate, endDate);
        } else {
          await refetch(selectedResource, startDate, endDate);
        }
      } else if (clientResourceId) {
        await refetch(clientResourceId, startDate, endDate);
      } else {
        setNotification({
          open: true,
          message: 'Please select a resource before refreshing bookings',
          severity: SEVERITY.ERROR,
        });
        return;
      }

      setNotification({
        open: true,
        message: 'Bookings refreshed successfully',
        severity: SEVERITY.SUCCESS,
      });
    } catch (error) {
      setNotification({
        open: true,
        message: 'Failed to refresh bookings',
        severity: SEVERITY.ERROR,
      });
    }
  };

  return (
    <>
      <Button startIcon={<RefreshCw size={16} />} onClick={handleRefresh}>
        Refresh
      </Button>
      <Notifications
        open={notification.open}
        message={notification.message}
        severity={notification.severity}
        onClose={() => setNotification(prev => ({ ...prev, open: false }))}
      />
    </>
  );
};

export default BookingRefreshButton;
